export const getDomainFromUrl = (url) => {
    try {
        if (typeof URL === 'undefined') {
            return url.split('/')[2];
        }
        return new URL(url).hostname;
    }
    catch (e) {
        // eslint-disable-next-line consistent-return
        return;
    }
};
